import styled from 'styled-components'

import { Box } from 'app/components/design-system-components'
import AIAnalyzerHeader from 'app/components/display/smartdocs/AIAnalyzerHeader'
import Explainer, {
  AnalysisDocumentBlock,
  AnalysisItem,
  DataType,
} from 'app/components/display/smartdocs/explainer'
import ExplainerCopilot, {
  CopilotDataProps,
} from 'app/components/display/smartdocs/ExplainerCopilot'
import { normalizeSmartDocsAnalysisBlocks } from 'app/components/display/smartdocs/helpers'

const StyledContainer = styled(Box)`
  border-radius: 8px;
  border: 2px solid var(--Deep-blue-link, #3774c3);
  background: var(--White, #fff);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 16px 24px;
  line-height: 1.4;
`

function ExplainerWithHeading({
  withLearnMore = true,
  isCopilot = true,
  data,
  onClickConfirmOKForAnalysis = () => {},
  onClickUndoForAnalysis = () => {},
  isRenterSide = true,
  copilotData,
  fromSummary = true,
  showOpenViewerLink = false,
  toggleDocumentsViewer,
}: {
  withLearnMore?: boolean
  isCopilot?: boolean
  data?: DataType | undefined
  onClickConfirmOKForAnalysis?: (analysisGUID: string) => void
  onClickUndoForAnalysis?: (
    analysisGUID: string,
    confirmationGUID: string,
  ) => void
  isRenterSide?: boolean
  copilotData?: CopilotDataProps[] | null | undefined
  fromSummary?: boolean
  showOpenViewerLink?: boolean
  toggleDocumentsViewer?: (docGUID: string) => void | undefined
}) {
  let totalDocNumber = 0
  let docNumberToCheck = 0
  if (data) {
    const allData = Object.values(data.analysis).flatMap((docAnalysis) =>
      normalizeSmartDocsAnalysisBlocks<AnalysisItem, AnalysisDocumentBlock>(
        docAnalysis,
      ),
    )

    allData?.forEach((item) => {
      item.fields.forEach((field) => {
        totalDocNumber++
        if (field?.status === 'unverified') {
          docNumberToCheck++
        }
      })
    })
    if (totalDocNumber === 0) {
      return null
    }
  }

  if (isCopilot && (copilotData === undefined || copilotData?.length === 0)) {
    return null
  }

  if (!isCopilot && data === undefined) {
    return null
  }

  return (
    <StyledContainer>
      <AIAnalyzerHeader
        isCopilot={isCopilot}
        withLearnMore={withLearnMore}
        copilotSuggestions={copilotData?.length}
        checkedItem={totalDocNumber}
        foundItems={docNumberToCheck}
      />
      <Box mt={2}>
        {isCopilot ? (
          <ExplainerCopilot
            copilotData={copilotData}
            fromSummary={fromSummary}
          />
        ) : (
          <Explainer
            isCopilot={isCopilot}
            data={data}
            onClickConfirmOKForAnalysis={onClickConfirmOKForAnalysis}
            onClickUndoForAnalysis={onClickUndoForAnalysis}
            isRenterSide={isRenterSide}
            showOpenViewerLink={showOpenViewerLink}
            toggleDocumentsViewer={toggleDocumentsViewer}
          />
        )}
      </Box>
    </StyledContainer>
  )
}

export default ExplainerWithHeading
